export default "__VITE_ASSET__BETY6eUO__"